import React, { useState, useEffect } from 'react';
import { theme, Modal, ButtonAnt } from '@pfmam/pfmam';
import styled, { createGlobalStyle } from 'styled-components';
import { Modal as antmodal, Radio, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import AppLayout from '../../common/layouts/appLayout';
import { Box } from '../../styles/globalStyle';
import { useSelector } from 'react-redux';

export const OverrideStyles = createGlobalStyle`
  .ant-modal-footer {
    border-top:none;
  }
    .ant-radio-checked .ant-radio-inner,
    .ant-radio:hover .ant-radio-inner,
    .ant-radio-checked::after,
    .ant-radio-wrapper:hover .ant-radio, 
    .ant-radio:hover .ant-radio-inner, 
    .ant-radio-input:focus + .ant-radio-inner {
        border-color: ${theme.colors.blue_primay};
    }
    .ant-radio-wrapper {
        font-size: ${theme.font_size.size_xl};
        color: ${theme.colors.black_secondary};
    }
    .ant-radio-inner::after {
        background-color: ${theme.colors.blue_primay};
    }
    .ant-radio-input:focus + .ant-radio-inner {
        box-shadow: none;
    }
`;

const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
  }
`;


const TrusteeAccountStopperComponent = (props) => {
    const { setTrusteeComponent } = props;
    const primary_color = useSelector((state) => state.siteInfo.primaryColor);
    const history = useHistory();
    const [trusteeAccStopperPopUpVisible, setTrusteeAccStopperPopUpVisible] = useState(false);
    const [confirmPopUpVisible, setConfirmPopUpVisible] = useState(false);

    useEffect(() => {
        setTrusteeAccStopperPopUpVisible(true);
    }, []);

    const onOptionChange = (e) => {
        if (e.target.value == 1) {
            setTrusteeAccStopperPopUpVisible(false);
            setConfirmPopUpVisible(true);
        } else {
            //Navigate to Account creation screen.
            history.push("/create-account", { canNavigate : true});
            setTrusteeComponent(false);
        }
    }

    const handleCancelButtonClick = () => {
        setTrusteeComponent(false);
    };

    return (
        <AppLayout>
            <OverrideStyles />
            {trusteeAccStopperPopUpVisible && (
                <Modal
                    width={740}
                    style={{
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)', // Add box shadow here
                        borderRadius: '8px', // Optional: Add rounded corners
                    }}
                    bodyStyle={{
                        padding: '50px 40px 10px 32px',
                    }}
                    maskStyle={{
                        backgroundColor: `${theme.rgba.modal}`,
                        zIndex: '1051',
                    }}
                    content={
                        <>
                            <p style={{ fontSize: "16px", lineHeight: "20px", whiteSpace: "normal" }}>
                                Is this account being set up for a Trustee Use?
                            </p> 
                            <br></br>
                            <p style={{ fontSize: "16px", lineHeight: "20px", whiteSpace: "normal" }}>
                                A Bank Trustee is a contact with a financial institution tasked with controlling the investment account. Most common for accounts related to bond proceeds or escrows.
                            </p>
                        </>
                    }
                    visible={trusteeAccStopperPopUpVisible}
                    onCancel={handleCancelButtonClick}
                    centered={true}
                    closable={true}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    maskClosable={false}
                    footer={
                        <>
                            <div style={{ fontSize: "16px", display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: "10px" }}>
                                <Radio.Group size="large" onChange={(e) => onOptionChange(e)}>
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </div>
                        </>
                    }
                />
            )}

            {confirmPopUpVisible && (
                <Modal
                    width={690}
                    style={{
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)', // Add box shadow here
                        borderRadius: '8px', // Optional: Add rounded corners
                    }}
                    bodyStyle={{
                        padding: '20px 32px 0px 32px',
                    }}
                    maskStyle={{
                        backgroundColor: `${theme.rgba.modal}`,
                        zIndex: '1051',
                    }}
                    content={
                        <>
                            <p style={{ textAlign: "center", padding: "40px", fontSize: "16px" }}>
                                Please contact Client Services Group for assistance on setting up a new account.
                            </p>
                            <Box display="flex" justifycontent="center">
                                <OverrideButtonAnt
                                    linkTextColor={primary_color}
                                    type="secondary"
                                    htmlType="button"
                                    label="Send a Secure Message"
                                    onClick={() => history.push("/contact")}
                                />
                            </Box>
                        </>
                    }
                    visible={confirmPopUpVisible}
                    onCancel={handleCancelButtonClick}
                    centered={true}
                    closable={true}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    maskClosable={false}
                    footer={
                        <>
                        </>
                    }
                />
            )}
        </AppLayout>
    );
};

export default TrusteeAccountStopperComponent;